import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.0049 0C12.8693 0 13.5703 0.700997 13.5703 1.56543V10.4336H22.4346C23.2989 10.4337 24 11.1346 24 11.999C23.9999 12.8633 23.2989 13.5644 22.4346 13.5645H13.5703V22.4346C13.5702 23.2989 12.8693 24 12.0049 24C11.1406 23.9999 10.4395 23.2989 10.4395 22.4346V13.5645H1.56543C0.701076 13.5645 0.000127677 12.8633 0 11.999C0 11.1346 0.700997 10.4336 1.56543 10.4336H10.4395V1.56543C10.4395 0.701076 11.1406 0.000127677 12.0049 0Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
